import { NgModule } from '@angular/core';
import { CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsCommitmentFocusStatusComponent } from './commitment-status.component';

@NgModule({
    declarations: [CmpsCommitmentFocusStatusComponent],
    imports: [CmpsIconModule],
    exports: [CmpsCommitmentFocusStatusComponent],
})
export class CmpsCommitmentFocusStatusModule {}
